module.exports = __webpack_public_path__ + "media/images/machine nespresso-be24ebca6cc649ee407b87c75d2485e7.svg";